import React from "react";
import PulseLoader from "react-spinners/PulseLoader";
import { LucideIcon } from "lucide-react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: LucideIcon | React.ComponentType<{ size?: number; color?: string; className?: string }>;
  iconColor?: string;
  isLoading?: boolean;
  actions?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  icon: Icon,
  iconColor = "#EE3F7C",
  isLoading = false,
  actions,
}) => {
  return (
    <div
      className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 mb-4 page-header-responsive"
      style={{ position: "relative", zIndex: 10 }}
    >
      <div>
        <h1 className="contact-header-title d-flex align-items-center gap-2">
          {Icon && <Icon size={24} color={iconColor} />}
          {title}
          {isLoading && <PulseLoader color={iconColor} size={8} className="ms-2" />}
        </h1>
        {subtitle && <p className="contact-header-subtitle mb-0">{subtitle}</p>}
      </div>
      {actions && <div className="d-flex align-items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
};

export default PageHeader;
